import { render, staticRenderFns } from "./HotCompanyGrid.vue?vue&type=template&id=ff1e6172&scoped=true"
import script from "./HotCompanyGrid.vue?vue&type=script&lang=js"
export * from "./HotCompanyGrid.vue?vue&type=script&lang=js"
import style0 from "./HotCompanyGrid.vue?vue&type=style&index=0&id=ff1e6172&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1e6172",
  null
  
)

export default component.exports